/**
 * Aplica una plantilla parametrizada RIPS al formData del registro.
 * @param {'consulta'|'procedimiento'} tipo
 * @param {object|null} plantilla
 * @param {object} [extras] campos adicionales (precio, lista_precios_id, etc.)
 */

/**
 * Pago moderador opcional: vacío / no numérico → "0".
 */
export function normalizarValorPagoModerador(valor) {
    if (valor === null || valor === undefined) return '0';
    const texto = String(valor).trim();
    if (texto === '' || texto.toLowerCase() === 'null' || texto.toLowerCase() === 'undefined') {
        return '0';
    }
    const num = Number(texto);
    if (!Number.isFinite(num) || num < 0) return '0';
    return String(num);
}

export function mapPlantillaRipsToForm(tipo, plantilla, extras = {}) {
    if (!plantilla) {
        return {
            ...extras,
            valorpagomoderador: normalizarValorPagoModerador(extras.valorpagomoderador),
        };
    }

    if (tipo === 'procedimiento') {
        return {
            ...extras,
            cupsp: plantilla.codProcedimiento || plantilla.servicio_cups || extras.cupsp || '',
            modalidad_procedimiento: plantilla.modalidadGrupoServicioTecSal || '01',
            grupo_servicios_procedimientos: plantilla.grupoServicios || '01',
            servicios_procedimientos: plantilla.codServicio || '',
            finalidadprocedimiento: plantilla.finalidadTecnologiaSalud || '',
            cie10p: plantilla.codDiagnosticoPrincipal || '',
            cie10p1: plantilla.codDiagnosticoRelacionado || '',
            cie10pc: plantilla.codComplicacion || '',
            conceptoRecaudo: plantilla.conceptoRecaudo || extras.conceptoRecaudo || '05',
            valorpagomoderador: normalizarValorPagoModerador(plantilla.valorPagoModerador),
        };
    }

    return {
        ...extras,
        cupsc: plantilla.codConsulta || plantilla.servicio_cups || extras.cupsc || '',
        modalidad_consulta: plantilla.modalidadGrupoServicioTecSal || '01',
        grupo_servicios: plantilla.grupoServicios || '01',
        servicios: plantilla.codServicio || '',
        finalidadconsulta: plantilla.finalidadTecnologiaSalud || '',
        causaexternaconsulta: plantilla.causaMotivoAtencion || '',
        cie10c: plantilla.codDiagnosticoPrincipal || '',
        cie10c1: plantilla.codDiagnosticoRelacionado1 || '',
        cie10c2: plantilla.codDiagnosticoRelacionado2 || '',
        cie10c3: plantilla.codDiagnosticoRelacionado3 || '',
        conceptoRecaudo: plantilla.conceptoRecaudo || extras.conceptoRecaudo || '05',
        valorpagomoderador: normalizarValorPagoModerador(plantilla.valorPagoModerador),
    };
}

/**
 * Busca plantilla por lista_precios_id o por CUPS.
 */
export async function fetchPlantillaRips(axios, { tipo, listaPreciosId, cups }) {
    try {
        if (listaPreciosId) {
            const r = await axios.get('/parametrizar-servicios-rips/por-lista', {
                params: { tipo, lista_precios_id: listaPreciosId },
            });
            if (r.data?.plantilla) return r.data.plantilla;
        }
        if (cups) {
            const r = await axios.get('/parametrizar-servicios-rips/por-cups', {
                params: { tipo, cups },
            });
            if (r.data?.plantilla) return r.data.plantilla;
        }
    } catch (e) {
        // Sin plantilla: flujo normal
    }
    return null;
}
